import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const Return = () => {
    document.title = "Qaytarma";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Alışlar", value: "/supplies" },
        { name: "Qaytarma", value: "/supplies/return", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Qaytarma</h2>
                    <p>
                        Alışların geri qaytarması sənədi, anbarda olan məshulların təchizatçıya geri qaytarılması üçündür. Nümunəyə baxaraq bu sənədi yarada
                        bilərsiniz. Yeni yaradılmış alışların qaytarılması sənədini ardıcıllıqla doldurub <SaveButton /> düyməsini sıxın.
                    </p>
                    <img src="/images/supplies/return.gif" alt="Qaytarma" />
                </article>
            </div>
        </div>
    );
};
